import type { UserRole } from '@/types/entities';

export const RoleNames = {
  Admin: 'ADMIN' as UserRole,
  Student: 'STUDENT' as UserRole,
  Biometric: 'BIOMETRIC' as UserRole,
  QuestionManagement: 'QUESTION_MANAGEMENT' as UserRole,
  LocationManager: 'LOCATION_MANAGER' as UserRole,
  ExamOfficer: 'EXAM_OFFICER' as UserRole,
  TechnicalSupportOfficer: 'TECHNICAL_SUPPORT_OFFICER' as UserRole,
} as const;

export function hasRole(roles: UserRole[], role: UserRole): boolean {
  return roles.includes(role);
}

export function canAccess(userRoles: UserRole[], requiredRole: UserRole): boolean {
  if (userRoles.includes('ADMIN')) {
    return true;
  }
  return userRoles.includes(requiredRole);
}

export function getDefaultRouteForRole(userRoles: UserRole[]): string {
  if (userRoles.includes('ADMIN')) {
    return '/dashboard';
  }
  if (userRoles.includes('BIOMETRIC')) {
    return '/dashboard/registrations';
  }
  if (userRoles.includes('QUESTION_MANAGEMENT')) {
    return '/dashboard/question';
  }
  if (userRoles.includes('LOCATION_MANAGER')) {
    return '/dashboard/venues';
  }
  if (userRoles.includes('EXAM_OFFICER')) {
    return '/dashboard/exam-operations';
  }
  if (userRoles.includes('TECHNICAL_SUPPORT_OFFICER')) {
    return '/dashboard/exam-operations';
  }
  if (userRoles.includes('STUDENT')) {
    return '/exam';
  }
  return '/admin';
}

export function getLoginRedirectPath(role?: UserRole): string {
  switch (role) {
    case 'ADMIN':
      return '/dashboard';
    case 'BIOMETRIC':
      return '/dashboard/registrations';
    case 'QUESTION_MANAGEMENT':
      return '/dashboard/question';
    case 'LOCATION_MANAGER':
      return '/dashboard/venues';
    case 'EXAM_OFFICER':
      return '/dashboard/exam-operations';
    case 'TECHNICAL_SUPPORT_OFFICER':
      return '/dashboard/exam-operations';
    case 'STUDENT':
      return '/exam';
    default:
      return '/admin';
  }
}

export function normalizeRoles(roles: UserRole | UserRole[]): UserRole[] {
  return Array.isArray(roles) ? roles : [roles];
}
